import React, {
  useRef,
  useEffect,
  useState,
  useContext,
  Fragment,
} from "react";
import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import FileChooser from "./FileChooser";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import DashboardStyledMenu from "./styled components/DashboardStyledMenu";
import Dialog_AddWorkspace from "./Dialog_AddWorkspace";
import CustomAlert from "./CustomAlert";
import DashboardPanelHeader from "./DashboardPanelHeader";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
} from "@syncfusion/ej2-react-grids";
import { CredsContext, HelpModeContext } from "./Contexts";
import Tools from "./JNSTools";

import "./styles/DashboardProjectDocuments.css";

function DashboardProjectDocuments(props) {
  const [displayPage, setDisplayPage] = useState();
  const [confirmEnabled, setConfirmEnabled] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [attachmentArray, setAttachmentArray] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [localWait, setLocalWait] = useState(false);

  const creds = useContext(CredsContext).creds;
  const helpMode = useContext(HelpModeContext).mode;

  const workspaceid = useRef();
  const clickCount = useRef(0);
  const newAttachment = useRef({
    id: "",
    size: "",
    description: "",
    file: "",
  });

  const projectObject = JSON.parse(sessionStorage.getItem("projectObject"));

  const urlString = Tools.getInstanceUrl(creds);
  const authString = Tools.getXmlBodyAuthString(creds);

  const handleDotsClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDotsClose = () => {
    setAnchorEl(null);
  };

  const openDotsMenu = Boolean(anchorEl);

  async function getAttachments() {
    //props.waitHandler(true);

    //if (!attachmentArray) {
    const authString = Tools.getXmlBodyAuthString(creds);
    const urlString = Tools.getInstanceUrl(creds);
    const requestString =
      authString +
      '<Read type="Workspacelink" method="equal to" limit="1"><Workspacelink><recordid>' +
      projectObject.id +
      "</recordid></Workspacelink></Read></request>";

    const wsLinkResponse = await Tools.fetchPost(
      requestString,
      urlString,
      "Workspacelink",
    );
    const wsLinkArray = Tools.xmlToArray(wsLinkResponse.xml);
    if (wsLinkArray.length > 0) {
      workspaceid.current = wsLinkArray[0].workspaceid;
      const attachmentRequestString =
        authString +
        '<Read type="Attachment" method="equal to" limit="1000"><Attachment><workspaceid>' +
        wsLinkArray[0].workspaceid +
        "</workspaceid></Attachment></Read></request>";
      const attachmentResponse = await Tools.fetchPost(
        attachmentRequestString,
        urlString,
        "Attachment",
      );

      setAttachmentArray(Tools.xmlToArray(attachmentResponse.xml));
    }
    //}
    return true;
  }

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleOpen = () => {
    if (!workspaceid.current) {
      const tempWsId = sessionStorage.getItem("tempWorkspaceId");
      if (tempWsId) {
        workspaceid.current = tempWsId;
        localStorage.removeItem("tempWorkspaceId");
      }
    }
    setOpenDialog(true);
  };

  const handleTextFieldValueChange = (event) => {
    newAttachment.current.description = event.target.value;
    if (
      newAttachment.current.description != "" &&
      newAttachment.current.file != ""
    ) {
      setConfirmEnabled(true);
    } else {
      setConfirmEnabled(false);
    }
  };

  const handleFileChange = (event) => {
    newAttachment.current.file = event;
    if (
      newAttachment.current.description != "" &&
      newAttachment.current.file != ""
    ) {
      setConfirmEnabled(true);
    } else {
      setConfirmEnabled(false);
    }
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(newAttachment.current.file);
      reader.onload = () =>
        resolve(reader.result.substring(reader.result.indexOf("base64,") + 7));
      reader.onerror = reject;
    });

  const handleConfirm = async () => {
    clickCount.current++;
    handleClose();
    if (
      newAttachment.current.description &&
      newAttachment.current.file &&
      clickCount.current == 1
    ) {
      props.waitHandler(true);
      const base64data = await toBase64(newAttachment.current.file);

      /*const newAttachmentValue = JSON.parse(
        JSON.stringify(newAttachment.current),
      );*/

      const requestString =
        authString +
        '<Add type="Attachment"><Attachment><name>' +
        newAttachment.current.description +
        "</name><file_name>" +
        newAttachment.current.file.name +
        //newAttachment.current.description +
        "</file_name><workspaceid>" +
        workspaceid.current +
        "</workspaceid><base64_data>" +
        base64data +
        "</base64_data><notes>Added through Addolution CollabCenter</notes></Attachment></Add></request>";

      Tools.fetchPost(requestString, urlString, "Attachment").then((newRec) => {
        const newRecArray = Tools.xmlToArray(newRec.xml);
        const newId = newRecArray[0].id;

        // this shouldn't be necessary, but OA....
        const modifyRequestString =
          authString +
          '<Modify type="Attachment"><Attachment><id>' +
          newId +
          "</id><name>" +
          newAttachment.current.description +
          "</name></Attachment></Modify></request>";
        Tools.fetchPost(modifyRequestString, urlString);

        const todayOrig = new Date();
        const utc = todayOrig.getTime() + todayOrig.getTimezoneOffset() * 60000;

        const today = new Date(utc + 3600000 * -5);

        const todayYear = today.getFullYear();
        let todayMonth = today.getMonth() + 1;
        if (todayMonth < 10) {
          todayMonth = "0" + todayMonth;
        }
        let todayDay = today.getDate();
        if (todayDay < 10) {
          todayDay = "0" + todayDay;
        }

        const timeStr = today.toTimeString();
        const updatedTime =
          timeStr.substring(0, 2) +
          timeStr.substring(3, 5) +
          timeStr.substring(6, 8);
        const updatedDate = todayMonth.toString() + todayDay + todayYear;
        const newAttachmentArrayRecord = {
          id: newId,
          name: newAttachment.current.description,
          size: base64data.length * 0.75,
          updated: updatedTime + updatedDate,
          file_name: newAttachment.current.file.name,
        };

        const tempArray = JSON.parse(JSON.stringify(attachmentArray));
        tempArray.push(newAttachmentArrayRecord);

        props.waitHandler(false);
        newAttachment.current = {
          id: "",
          size: "",
          description: "",
          file: "",
        };
        setAttachmentArray(tempArray);
      });
    }
    clickCount.current = 0;
  };

  const removeAttachment = (event) => {
    let element = event.target;
    let attachmentinfo;
    let brakes = 0;
    do {
      attachmentinfo = element.dataset.attachmentinfo;
      element = element.parentElement;
      brakes++;
    } while (!attachmentinfo && brakes < 100);

    const tempAttachmentArray = JSON.parse(JSON.stringify(attachmentArray));
    //const delIndex = tempAttachmentArray.findIndex(
    //  (elem) => elem.id == attachmentinfo,
    //);
    const delIndex = attachmentinfo;
    tempAttachmentArray.splice(delIndex, 1);

    const deleteString =
      authString +
      '<Delete type="Attachment"><Attachment><id>' +
      attachmentArray[attachmentinfo].id +
      "</id></Attachment></Delete></request>";
    Tools.fetchPost(deleteString, urlString);

    handleDotsClose();
    setAttachmentArray(tempAttachmentArray);
  };

  const downloadFile = (event) => {
    props.waitHandler(true);
    const attachmentid = event.target.dataset.attachmentid;

    const downloadString =
      authString +
      '<Read type="Attachment" method="equal to" limit="1"><Attachment><id>' +
      attachmentid +
      "</id></Attachment></Read></request>";

    Tools.fetchPost(downloadString, urlString, "Attachment").then(
      (attachmentData) => {
        const tempArray = Tools.xmlToArray(attachmentData.xml);
        let fetchDataModified =
          "data:application/pdf;base64," + tempArray[0].base64_data;
        let a = document.createElement("a");
        a.href = fetchDataModified;
        a.download = tempArray[0].file_name;
        a.click();
        props.waitHandler(false);
      },
    );
  };

  /*useEffect(() => {
    setLocalWait(true);
    getAttachments().then(() => {
      setLocalWait(false);
    });
  }, []);*/

  const linkColumnTemplate = (link) => {
    return (
      <span
        className="projectDocumentNameCell"
        onClick={downloadFile}
        data-attachmentid={link.id}
      >
        {link.name}
      </span>
    );
  };

  const typeColumnTemplate = (link) => {
    const extension = link.file_name.substring(link.file_name.indexOf(".") + 1);
    const typeIconSrc = Tools.getExtensionIcon(extension);
    return (
      <div className="image">
        <img src={"./file_type_icons/" + typeIconSrc} height="30px" />
      </div>
    );
  };

  const headerTemplate = (event) => {
    return <span className="dashHeaderRow">{event.headerText}</span>;
  };

  const dotsColumnTemplate = (props2) => {
    return (
      <Box
        onClick={helpMode ? null : handleDotsClick}
        id={helpMode ? "__dashboardProjectDocumentsMenu" : props2.index}
        rowindex={props2.index}
        sx={{
          height: "25px",
          width: "25px",
          cursor: helpMode ? "help" : "pointer",
          color: "gray",
          borderRadius: "25px",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <MoreVertIcon rowindex={props2.index} />
      </Box>
    );
  };

  const handleConfirmationClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenConfirmation(false);
  };

  const handleAlertClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenDialog(false);
  };

  const addAttachmentComponent = (
    <AttachFileIcon
      id="__dashboardProjectLinksAdd"
      //onClick={helpMode ? null : handleOpen}
      onClick={handleOpen}
      fontSize="small"
      sx={{
        marginRight: "5px",
        //cursor: helpMode ? "help" : "pointer",
      }}
    />
  );
  /*
  if (props.attachmentArray) {
    setLocalWait(false);
  } else {
    setLocalWait(true);
  }
*/
  /*useEffect(() => {
    const prepDisplayPage = (
    */
  return (
    <Fragment>
      <CustomAlert
        alertText="Workspace Created"
        openAlert={openConfirmation}
        setOpenAlert={setOpenConfirmation}
      />
      <Box height="12%" className="dashTableTitleBar">
        <DashboardPanelHeader
          panelLocked={props.panelLocked}
          title="Attachments"
          removePanel={props.removePanel}
          panelId={props.panelId}
          headerComponent={addAttachmentComponent}
        />
      </Box>

      <Box
        height="85%"
        id="__dashboardProjectDocuments_grid"
        sx={{
          overflow: "auto",
          verticalAlign: "middle",
          border: "solid 2px",
          padding: "0px 4px 4px 4px",
          borderRadius: "0px 0px 6px 6px",
          backgroundColor: "white",
          position: "absolute",
        }}
      >
        <Backdrop
          sx={{ color: "#fff", position: "absolute", zIndex: 10 }} //, zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={!props.attachmentArray}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <GridComponent
          className="gridWithNoHeader"
          enableStickyHeader={true}
          dataSource={props.attachmentArray}
        >
          <ColumnsDirective>
            <ColumnDirective
              field="name"
              width="40px"
              headerText=""
              textAlign="Left"
              template={typeColumnTemplate}
              headerTemplate={headerTemplate}
              customAttributes={{ class: "projectDocumentNameCell" }}
            />
            <ColumnDirective
              field="name"
              headerText="Name"
              textAlign="Left"
              template={linkColumnTemplate}
              headerTemplate={headerTemplate}
              customAttributes={{ class: "projectDocumentNameCell" }}
            />
            <ColumnDirective
              field="dots"
              width="25"
              headerText=""
              textAlign="Right"
              template={dotsColumnTemplate}
              headerTemplate={headerTemplate}
              customAttributes={{ class: "projectTeamDotsCell" }}
            />
          </ColumnsDirective>
        </GridComponent>
      </Box>
      <Dialog open={openDialog} onClose={handleClose} maxWidth="400px">
        {workspaceid.current ? (
          <Box
            sx={{
              backgroundColor: "gainsboro",
              padding: "10px",
              border: "solid 2px",
            }}
          >
            <Typography
              sx={{
                fontSize: "large",
                backgroundColor: "#643f69",
                color: "white",
                borderRadius: "5px",
                paddingLeft: "5px",
                marginBottom: "15px",
              }}
            >
              Add Attachment
            </Typography>
            <Box sx={{ display: "inline-block" }}>
              <TextField
                required
                id="__dashboardProjectDocumentsDescription"
                onChange={handleTextFieldValueChange}
                variant="standard"
                label="Display Name"
                sx={{
                  margin: "0px 10px",
                  width: "250px",
                  verticalAlign: "middle",
                }}
              ></TextField>
            </Box>
            <FileChooser
              changeHandler={handleFileChange}
              id="__dashboardProjectDocumentsFileChooser"
            />
            <br></br>
            <br></br>
            <DialogActions sx={{ justifyContent: "center" }}>
              <Button
                className="dialogConfirmCancelButton"
                onClick={helpMode ? null : handleClose}
              >
                Cancel
              </Button>
              <Button
                className="dialogConfirmCancelButton"
                onClick={helpMode ? null : handleConfirm}
                disabled={!confirmEnabled}
              >
                Confirm
              </Button>
            </DialogActions>
          </Box>
        ) : (
          <Dialog_AddWorkspace
            handleClose={handleClose}
            handleAlertClose={handleAlertClose}
            waitHandler={props.waitHandler}
            creds={creds}
            projectObject={projectObject}
            setOpenDialog={setOpenDialog}
            setOpenConfirmation={setOpenConfirmation}
          />
        )}
      </Dialog>
      <DashboardStyledMenu
        id="dotsMenu"
        open={openDotsMenu}
        anchorEl={anchorEl}
        onClose={handleDotsClose}
      >
        <MenuItem
          data-attachmentinfo={anchorEl ? anchorEl.id : null}
          onClick={removeAttachment}
        >
          Remove Attachment
        </MenuItem>
      </DashboardStyledMenu>
    </Fragment>
  );
  /*    setDisplayPage(prepDisplayPage);
  }, [
    openDialog,
    openConfirmation,
    openDotsMenu,
    attachmentArray,
    helpMode,
    confirmEnabled,
  ]);

  return displayPage;
  */
}

export default DashboardProjectDocuments;

DashboardProjectDocuments.propTypes = {
  waitHandler: PropTypes.func,
  panelLocked: PropTypes.bool,
  removePanel: PropTypes.func,
  panelId: PropTypes.number,
  attachmentArray: PropTypes.array,
};

/*              <TableCell className="projectTeamSubHeaderCell">Size</TableCell>*/
/*                <TableCell className="projectTeamNameCell">
                  {(parseFloat(elem.size) / 1048576).toFixed(2) + " MB"}
                </TableCell>*/

/*
<DialogContent
              sx={{
                overflow: "hidden",
                padding: "0px",
                backgroundColor: "#ed6c02",
              }}
            >
              <Alert
                variant="filled"
                onClose={handleAlertClose}
                severity="warning"
                sx={{
                  width: "95%",
                  fontSize: "large",
                  padding: "0px",
                  margin: "5px",
                }}
              >
                <Typography sx={{ padding: "25px" }}>
                  This project does not have an associated Openair workspace. In
                  order to add links a workspace must be created and linked to
                  this project. Click &quot;OK&quot; to create a workspace and
                  link it to this project.
                </Typography>
                <DialogActions sx={{ paddingRight: "30px" }}>
                  <Button
                    className="settingsButtonActive"
                    variant="filled"
                    value="OK"
                    onClick={createWorkspace}
                    sx={{ margin: "0px 10px 0px 0px !important" }}
                  >
                    OK
                  </Button>
                  <Button
                    className="settingsButtonActive"
                    variant="filled"
                    value="Cancel"
                    onClick={handleClose}
                    sx={{ margin: "0px !important" }}
                  >
                    Cancel
                  </Button>
                </DialogActions>
              </Alert>
            </DialogContent>
            */
